import { BlockComponentProps } from 'client-react-block-renderer/src';
import { CrudStatus } from 'forms-crud';
import { isOwner } from 'pws-client';
import React, { useCallback, useState } from 'react';
import * as api from '../api';
import PwsPopupEditor from './PwsPopupEditor';
import { PopupData } from '../types';
import t from 'rcm-i18n';

interface Data {
    popupOptions: PopupData[];
    currentPopupId: string;
}

const PwsHomePagePopupsBlock = (props: BlockComponentProps<Data>) => {
    const [currentPopupId, setCurrentPopupId] =
        useState(props.data.currentPopupId);

    const [status, setStatus] = useState<CrudStatus>('ready');

    const handleSelectPopup = useCallback(async (popupId: string) => {
        setStatus('saving');
        try {
            await api.save({ currentPopupId: popupId });
            setCurrentPopupId(popupId);
            setStatus('saved');
        } catch {
            setStatus('error');
        }
    }, []);

    return (!isOwner()) ? <>
        {t('You are not allowed to view this content.')}
    </> : <PwsPopupEditor
        popupOptions={props.data.popupOptions}
        status={status}
        currentPopupId={currentPopupId}
        onSelectPopup={handleSelectPopup}
    />;
};

export default PwsHomePagePopupsBlock;
